<div class="container">
    <div class="half-container">
        <p class="title">{{'TITLE_DEVICES' | translate}}</p>
        <p class="subtitle">{{'SUBTITLE_DEVICES' | translate}}</p>
    </div>
    <div class="half-container">
      
        <div class="divRigthContainer">
            
            <button style=" height: 32px;
            background-color: #3FA9F5;
            color: white;" class="confirm-ico-btn" mat-raised-button (click)="gotoSaveDevice()"> 
              <span class="fas fa-plus"></span> 
              {{'LABEL_BUTTON_DEVICES' | translate}}
          </button>
        </div>
     

    </div>
    


</div>

<neoris-grid [ColumnsConfiguration]="gridColumnsConfiguration"  [ShowChecks]="false"  [GridTitle]="'SUBTITLE_DEVICE_MANAGEMENT' | translate" [Data]="arrayGirdDeviceManagementGrid" (cellClickEvent)="cellClick($event)"></neoris-grid>


